import { AggregatedArticle } from "@coworker/app/src/components/RoomSettings/hooks/useAggregatedArticles";
import {
  Article,
  EdsData,
} from "@coworker/app/src/components/RoomSettings/types/article";
import { Media } from "@coworker/app/src/components/RoomSettings/types/media";
import { ItemDelete } from "@coworker/apprestructured/src/media-maintenance/components/item-cards/ItemDelete/ItemDelete";
import { ItemQuantityStepper } from "@coworker/apprestructured/src/media-maintenance/components/item-cards/ItemQuantityStepper/ItemQuantityStepper";
import { MediaItemCardWithActions } from "@coworker/apprestructured/src/media-maintenance/components/item-cards/MediaItemCardWithActions/MediaItemCardWithActions";
import { MediaItemViewType } from "@coworker/apprestructured/src/media-maintenance/types/mediaItemViewType";
import { Spacer } from "@coworker/apprestructured/src/shared/components/Spacer/Spacer";
import { ItemStockInfo } from "@coworker/apprestructured/src/shared/hooks/item/useItemStock";
import { Item } from "@coworker/apprestructured/src/shared/types/item";
import { ItemBadge } from "@coworker/apprestructured/src/shared/types/ItemBadge";
import { ItemCardRenderType } from "@coworker/apprestructured/src/shared/types/itemCardRenderType";
import styles from "../../../styles/common-media-styles.module.css";

type MediaItemCardDefaultBaseProps<T extends Article | AggregatedArticle> = {
  item: Item;
  article: T;
  itemCardRenderType: ItemCardRenderType;
  edsData?: EdsData | null;
  badges?: ItemBadge[];
  saleStartDate?: string;
  mediaItemViewType?: MediaItemViewType;
  shouldDisplayQuantity?: boolean;
  totalQuantityPieces?: number;
  stockInfo?: ItemStockInfo;
};

type MediaItemCardDefaultProps<T extends Article | AggregatedArticle> =
  | (MediaItemCardDefaultBaseProps<T> & { showActions?: false; media?: Media })
  | (MediaItemCardDefaultBaseProps<T> & { showActions: true; media: Media });

export const MediaItemCardDefault = <T extends Article | AggregatedArticle>(
  props: MediaItemCardDefaultProps<T>
) => {
  const {
    item,
    article,
    showActions = false,
    itemCardRenderType = ItemCardRenderType.link,
    edsData,
    badges,
    saleStartDate,
    mediaItemViewType = MediaItemViewType.SIMPLE_ITEM_VIEW,
    shouldDisplayQuantity = false,
    totalQuantityPieces,
    stockInfo,
  } = props;
  const media = showActions ? props.media : undefined;
  return (
    <MediaItemCardWithActions
      mediaItemViewType={mediaItemViewType}
      badges={badges || []}
      itemCardRenderType={itemCardRenderType}
      item={item}
      edsData={edsData ?? null}
      article={article}
      saleStartDate={saleStartDate}
      stockInfo={stockInfo}
      shouldDisplayQuantity={shouldDisplayQuantity}
      totalQuantityPieces={totalQuantityPieces}
      renderActions={() =>
        showActions && media ? (
          <>
            <Spacer />
            <div className={styles["item-card-action-row"]}>
              <ItemQuantityStepper
                itemNo={item.no}
                itemQuantityPieces={article?.nbrArticles ?? 0}
                article={article}
              />
              <ItemDelete
                itemNo={article.productArticleId}
                isItemInMultipleGroups={false}
                article={article}
                media={media}
              />
            </div>
          </>
        ) : null
      }
    />
  );
};
